export const navigation = [
    { name: 'Home', href: '/', current: true },
    // { name: 'About', href: '/about', current: false },
    { name: 'Blog', href: '/blog', current: false },
    { name: 'Contact', href: '/contact', current: false },
  ]